export default {
  noPaper: 'No paper',
  arrangementTime: 'arrangement time',
  tabEnd: 'end',
  tabVideo: 'video',
  tabPaper: 'Questions',
  videoStatus: {
    notStart: 'Not started',
    connect: 'Can be connected',
    interviewing: 'On video',
    hangup: 'Hang up',
    ended: 'ended',
    checkIn: 'logged in',
    online: 'online',
    offline: 'offline',
  },
  fraud: 'Fraud',
  fraudCancel: 'Unmark Fraud',
  absent: 'Withdraw',
  absentCancel: 'Cancel Withdrawal',
  exempt: 'Exempt',
  exemptCancel: 'Cancel Exemption',
  groupName: 'group',
  groupNumber: 'Number',
  number: '{number} number',
  view: 'View',
  noDataMsg: 'No rating table yet',
  yes: 'Yes',
  placeholder: {
    reason: 'Please enter the reason for the change',
    old_score: 'Please enter the original score',
    new_score: 'Please enter a new score',
  },
  fraudConfirmMsg:
    'After marking fraud, the candidate will not be rated and the result will be invalidated. Confirm the mark?',
  fraudCancelMsg: 'Confirm canceling the fraud flag for this candidate?',
  absentConfirmMsg:
    'After marking an absence, the candidate will not be graded and the grade will be void. Confirm marking?',
  absentCancelMsg: "Confirm canceling the candidate's absence mark?",
  exemptConfirmMsg: 'After marking exemption, the candidate cannot be scored. Confirm the mark?',
  exemptDeleteWarning: 'If scoring has started, all scoring records will be deleted and cannot be recovered!',
  exemptCancelMsg: 'Confirm canceling the candidate’s exemption mark?',
  signOutConfirmMsg: 'Sure to opt out of the interview scoring system?',
  signOutCancelMsg: 'Cancel exit',
  interviewingAlertMsg: 'The current contestant has not scored yet',
  scoreMsg: ["The current candidate's score is ", 'Result', ' Are you sure to submit it?'],
  scoreAlertMsg: 'Item "{msg}" has not been scored. Please enter a score before submitting.',
  error307: 'You have been scored by the administrator, click OK, you will be redirected to the home page',
  error401: 'Login expired, please login again',
  successMsg: {
    processing: 'Please wait patiently',
    confirmed: 'The administrator has approved the grade modification application',
    unconfirmed: 'The administrator has rejected the request for a grade change',
    default: 'Something went wrong',
  },
  applicationNotify: 'Application status notification',
  showHistoryNoData: 'This candidate has no score history',
  videoOpreateStartAlert: 'Interview time is not up, please hold on...',
  videoOpreateEndAlert: 'The interview has ended, please contact the administrator if necessary',
  btnContent: {
    waiting: 'Start scoring',
    interviewing: 'Finished',
    complete: 'complete',
    processing: 'Check application status',
    confirmed: 'Modified grade',
    unconfirmed: 'unconfirmed',
  },
  period: '.',
};
